import { Upload } from "lucide-react";

export default function UpdateButton({
  onClick,
  label = "Update",
  size = 12,              // icon size
  disabled = false,
  className = "",
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={`
        flex items-center gap-1
        rounded-lg border border-blue-200
        bg-blue-50 px-2.5 py-1.5
        text-[11px] font-semibold text-blue-700
        hover:bg-blue-100
        disabled:cursor-not-allowed disabled:opacity-60
        ${className}
      `}
    >
      <Upload className="w-3 h-3" />
      <span>{label}</span>
    </button>
  );
}
    